export enum WorkflowActionType {
    URL = 'URL',
    MAILING_LIST = 'MAILING_LIST',
    REGISTRATION = 'REGISTRATION',
    STUDY_REDIRECT = 'STUDY_REDIRECT'
}
